<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    withTitle: {
      type: Boolean,
      required: false,
      default: true,
      focus: true
    }
  },

  computed: {
    ...mapState("newOrder", ["additional_informations", "use_my_products"])
  },

  methods: {
    ...mapActions("newOrder", [
      "setAdditionalInformations",
      "setUseMyProducts"
    ]),

    focusTextArea() {
      this.$refs.description.focus();
    },

    focus() {
      this.focus = !this.focus;
    }
  },

  mounted() {
    this.focusTextArea();
  }
};
</script>

<template>
  <div id="informations" class="section" :class="{'bigger-section': focus}">
    <div v-if="withTitle" class="section-title">
      INFORMAÇÕES SOBRE A LIMPEZA
      <hr />
    </div>
    
    <small>
      Quando você preencher as informações ou instruções para o profissional, o próximo passo para finalizar a compra irá aparecer.
    </small>
    <small>
      <b>Importante:</b> o profissional <b>não levará balde, vassoura, rodo e escada.</b> Se esses itens forem necessários, devem estar disponíveis no local da limpeza.
    </small> 

    <div class="section-body">
      <textarea
        placeholder='Escreva aqui as instruções e cuidados para a limpeza. Por exemplo: "Fazer a limpeza do banheiro, quartos, sala e cozinha. Foco na limpeza do box, retirar mofo da parede da sala, limpeza dos pisos e retirada de pó. Por favor, afaste os móveis para limpar embaixo"...'
        name="description"
        ref="description"
        class="add-information"
        rows="5"
        maxlength="1023"
        :class="{'has-error': additional_informations.length === 1023, 'pulse': focus}"
        :value="additional_informations"
        @input="setAdditionalInformations($event.target.value)"
        @focus="focus()"
      ></textarea>
    </div>
  </div>
</template>

<style scoped>
textarea {
  resize: none;
}

#informations small {
  font-size: 12px;
}

small {
  color: var(--pink);
  margin-bottom: 10px;
  text-align: center;
}

.add-information {
  margin-top: 20px;
  padding: 10px;
  height: 120px;
  border-radius: 4px;
  border-color: rgb(175, 0, 107);
  margin-bottom: 10px;
}

.add-information.pulse {
  box-shadow: 0 0 0 rgba(175, 0, 107, 0.4);
  animation: pulse 2s infinite;
}

.section-body {
  width: 460px;
}

.section {
  margin-bottom: 10px !important;
}

.section.bigger-section {
  margin-bottom: 90px !important;
}

.radio-product {
  margin: 10px 0 0 20px;
  text-align: left;
  color: var(--pink);
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
}

.radio-product::before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  border: 2px solid var(--pink);
  border-radius: 100%;
  margin-right: 5px;
  transition: all 0.25s ease;
}

.radio-product.checked::before {
  background-size: 1px 1px;
  background-color: var(--pink);
}

.quote {
  margin-top: 10px;
  margin-left: 30px;
  text-align: left;
  border-left: 1px solid var(--pink);
  padding: 5px 10px;
  font-size: 13px;
}

@media (max-width: 720px) {
  .section-body {
    width: 100%;
  }
}

@media (max-width: 630px) {
  .section-body {
    width: 100%;
  }
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(175, 0, 107, 0.4);
    box-shadow: 0 0 0 0 rgba(175, 0, 107, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(175, 0, 107, 0);
    box-shadow: 0 0 0 10px rgba(175, 0, 107, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(175, 0, 107, 0);
    box-shadow: 0 0 0 0 rgba(175, 0, 107, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/AdditionalInformations.vue